import { Article } from '../../store/article';
import { Business } from '../../store/business';
import { CategoryShort } from '../../store/category';
import { International } from '../../store/international';
import { PaginatedResponse, PaginationProps } from '../../store/types';
import {
  DefaultFetchError,
  FetchGet,
  useFetchGet,
} from '../fetch';
import { SubCategory } from './createaccount';

export type SearchParams = PaginationProps & {
  search: string;
}

export type SearchData = {
  business: PaginatedResponse<Business>;
  categories: PaginatedResponse<CategoryShort>;
  subCategories: PaginatedResponse<SubCategory>;
  articles: PaginatedResponse<Article>;
  internationals: PaginatedResponse<International>;
}

export const useSearch = (): FetchGet<SearchData, SearchParams, DefaultFetchError> => (
  useFetchGet('common/search', { autoStart: false, startStateLoading: false, authorization: false })
);
